/*
 * Copyright (c) 2024 GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */

export const columns = [
  {
    name: "USER ID",
    selector: "userID",
    sortable: false
  },
  {
    name: "Full Name",
    selector: "fullname", //director fieled represents Full name
    sortable: false
  },
  {
    name: "Email Address",
    selector: "emailaddress",
    sortable: false
  },
  {
    name: "Action",
    selector: "action",
    sortable: false
  }
];

export const data = [
  {
    id: 1,
    userID: "DF2J4L",
    fullname: "Shafi Gilanizadeh",
    emailaddress: "Shafigilanizadeh@gm.com",
    logindetails: "Never logged in",
    action: ["Add"],
  },


];
